import React from 'react';
const ExtraControls = ({
    children
}) => {
    return (
        <div className="music-player-extra-controls">
            { children }
        </div>
    )
}
export default ExtraControls;